import * as React from "react";
import type { SVGProps } from "react";
const SvgClipboardWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.99 17H11v-.01c.31 0 .61-.15.8-.4l4.5-6c.33-.44.24-1.07-.2-1.4s-1.07-.24-1.4.2l-3.68 4.91-1.71-2.39a.994.994 0 0 0-1.39-.23c-.45.33-.55.95-.23 1.4l2.5 3.5c.18.26.48.42.8.42"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2a4 4 0 0 0-3.465 2H5c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-3.535A4 4 0 0 0 12 2m1.73 3c-.347-.597-.994-1-1.73-1s-1.383.403-1.73 1zM9 7c-.55 0-1-.45-1-1H6v14h12V6h-2c0 .55-.45 1-1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClipboardWithCheckMark;
